import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { BaseChartModel } from "@/Patient/Models/GrowthCharts/BaseChartModel";

interface GrowthChartsNavigationBarProps {
    activeChart: BaseChartModel;
    charts: BaseChartModel[];

    onChartSelected: (chart: BaseChartModel) => void;
}

class GrowthChartsNavigationBarState {}

class GrowthChartsNavigationBar extends BaseReactComponent<GrowthChartsNavigationBarProps, GrowthChartsNavigationBarState> {
    private navigationBarDivRef: HTMLElement | null;

    constructor(props: GrowthChartsNavigationBarProps) {
        super(props);

        this.navigationBarDivRef = null;
    }

    public componentDidMount(): void {
        window.addEventListener("wheel", this.onScroll);
    }

    public componentWillUnmount(): void {
        window.removeEventListener("wheel", this.onScroll);
    }

    public render(): JSX.Element {
        return (
            <div
                className="navigation-bar"
                ref={ref => (this.navigationBarDivRef = ref)}
            >
                {this.renderNav()}
            </div>
        );
    }

    private renderNav(): JSX.Element[] {
        return this.props.charts.map(chart => {
            const isChartActive = chart.id === this.props.activeChart.id;
            return (
                <button
                    data-cy={`growthCharts-${chart.id}Select`}
                    key={`growth-charts-navbar-${chart.id}`}
                    className={isChartActive ? "active" : ""}
                    onClick={() => this.props.onChartSelected?.(chart)}
                >
                    {isChartActive ? chart.name : chart.shortName}
                </button>
            );
        });
    }

    private onScroll = (e: WheelEvent): void => {
        this.navigationBarDivRef.scrollLeft += e.deltaY > 0
            ? 100
            : -100;
    };
}

export { GrowthChartsNavigationBar };
